import nextId from "react-id-generator";
import home1 from "../../images/home-bg-1.jpg"
import home2 from "../../images/home-bg-2.jpg"
import home3 from "../../images/home-bg-3.jpg"
import home4 from "../../images/home-bg-4.jpg"

export const homeSlides = [
    {
        id: nextId(),
        text: "be strong, be better",
        title: "Find your fitness truth & get better results faster",
        btnVal: "explore",
        image: home1
    },
    {
        id: nextId(),
        text: "be strong, be better",
        title: "Find your fitness truth & get better results faster",
        btnVal: "explore",
        image: home2
    },
    {
        id: nextId(),
        text: "be strong, be better",
        title: "Find your fitness truth & get better results faster",
        btnVal: "explore",
        image: home3
    },
    {
        id: nextId(),
        text: "be strong, be better",
        title: "Find your fitness truth & get better results faster",
        btnVal: "explore",
        image: home4
    },
]